export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/environments/environment.ts